module.exports = __webpack_public_path__ + "static/printing-19e9cd69fcfa267f761c6c3a8d2ee0a2.jpg";